export let logindataemail = [
    {
        "placeholder": "Enter Email",
        "formname": "email",
        "type": "email",
        "error": false,
        "patternerror": "Please enter a valid email"
    },
    {
        "placeholder": "Enter Password",
        "formname": "password",
        "type": "password",
        "error": false,

    }
]

export let regdata = [
    {
        "placeholder": "Enter Name",
        "formname": "name",
        "type": "text",

    },
    {
        "placeholder": "Enter Email",
        "formname": "email",
        "type": "email",
        "error": false,
        "patternerror": "Please enter a valid email"
    },

    {
        "placeholder": "Enter Password",
        "formname": "password",
        "type": "password",
        "error": false,
        "patternerror": "[a-z],[A-Z],[0-9],a special character"
    },

    {
        "placeholder": "Confirm Password",
        "formname": "confirmpassword",
        "type": "password",
        "error": false,
        "matcherror": "The passwords don't match"
    }
]

export let logindataphoneno = [

    {
        "placeholder": "Enter Phone Number",
        "formname": "phone",
        "type": "text",
        "error": false,
        "patternerror": "Please enter a valid phone number"
    }
]


